<template>
	<div class="login_forget_register_box">
		<div class="container">
			<v-logo></v-logo>
			<section class="login_box">
				<h4 class="login_title color_5babf4">
						信息验证
				</h4>
				<div class="login_form_box">
					<p class="tip_sub_text">
						<span>短信验证码已发送至</span>
						<span>{{csmobile}}</span>
					</p>
					<form action="#" method="">
						<div class="forget_yzm login_mbtm6 clearfix">
							<label class="label_focus" for="register_yzm">验证码</label>
							<input type="hidden" v-model="user.setMess" />
							<input type="text" @keyup.enter="resetPassword" class="form-control inline-block input_focus login_form" id="register_yzm" v-model="user.yzm" />
							<a href="javascript:;" class="btn btn_send pull-right text-center" id="notifywj" @click="notifywj()">发送</a>
							<span id="colwj" style="display: none;color: #ccc;">
									<label id="sendTimeswj" >倒计时60</label>
							    </span>
						</div>
						<div class="password login_mbtm6">
							<label class="label_focus" for="login_psw">密码</label>
							<input type="password" class="form-control input_focus login_form" @keyup.enter="resetPassword" maxlength="20" id="login_psw" v-model="user.password" />
						</div>
						<div class="password login_mbtm6">
							<label class="label_focus" for="login_psw1">确认密码</label>
							<input type="password" class="form-control input_focus login_form" @keyup.enter="resetPassword" maxlength="20" id="login_psw1" v-model="confirmPassword" />
						</div>
						<p class="tip_box">
							<small class="tip_yz"></small>
						</p>
						<p class="login_btn_box">
							<a class="btn btn_h btn_issue margin_r_7" id="resetPassword" @click="resetPassword()">重置密码</a>
							<small class="tip_sub_text cursor color_9" @click=" show = !show ">没有收到验证码?</small>
							|
							<router-link to="/login" class="color_308de2"><small>返回登录</small></router-link>
						</p>
					</form>
					<div class="text-center login_title">
						<!--<p class="text-center cursor" @click=" show = !show ">
							<small class="tip_sub_text">没有收到验证码?</small>
						</p>-->
						<div class="color_9" v-if="show">
							<p>
								<small>当您无法收到校验码短信市，请逐一排查以下原因：</small>
							</p>
							<p>
								<small>*手机话费余额不足或其他手机原因；</small>
							</p>
							<p>
								<small>*短信收件箱已满；</small>
							</p>
							<p>
								<small>*被手机安全软件误判而拦截；</small>
							</p>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
	import { MessageBox } from 'element-ui';
	import vLogo from './logo_head.vue'
	export default {
		name: 'register_msg_yz',
		components: {
			vLogo
		},
		data() {
			return {
				trueFlag: false,
				falseFlag: false,
				tipMsg: "",
				show: false,
				istrue: 0,
				csmobile: this.$route.params.mobile,
				user: {
					password: '',
					setMess: this.$route.params.memo,
					mobile: this.$route.params.mobile,
					yzm: ''
				},
				confirmPassword: '',
				tipNum: ''

			}
		},
		mounted: function() {
			this.$nextTick(function() {
				this.$inputFocus(".input_focus");
				this.cshyzm();
			})
		},
		methods: {
			cshyzm() {
				var Num = "",
					mestimer;
				$("#notifywj").css("display", "none");
				clearInterval(mestimer);
				//倒计时
				$("#colwj").css("display", "inline-block");
				var second = 60; // 剩余秒数
				//然后写一个定时器
				mestimer = setInterval(function() {
					second--;
					$("#sendTimeswj").html("倒计时" + " " + second);
					if(second == -1) {
						$("#sendTimeswj").html("倒计时关闭");
						clearInterval(mestimer);
						$("#colwj").css("display", "none");
						$("#notifywj").css("display", "inline-block");
						Num = "";
					}
				}, 1000);
			},
			notifywj() {
				var Num = "";
				var user = this.$route.params;
				var temp = this;
				var mestimer;
				if(typeof(user.mobile) == "undefined") {
					return;
				}
				if(typeof(user.memo) == "undefined") {
					return;
				}
				var formData = JSON.stringify(user);
				clearInterval(mestimer);
				this.$http.post('/zklccloud/register/zhaohuizcfs', formData, {
					emulateJSON: true
				}).then(function(m) {
					if(m.body.resultCode == 0) {
						temp.user.setMess = m.body.content.memo;
						$("#notifywj").css("display", "none");
						//倒计时
						$("#colwj").css("display", "inline-block");
						var second = 60; // 剩余秒数
						//然后写一个定时器
						mestimer = setInterval(function() {
							second--;
							$("#sendTimeswj").html("倒计时" + " " + second);
							if(second == -1) {
								$("#sendTimeswj").html("倒计时关闭");
								clearInterval(mestimer);
								$("#colwj").css("display", "none");
								$("#notifywj").css("display", "inline-block");
								Num = "";
							}
						}, 1000);
					} else {
						$(".tip_yz").text('发送验证码失败,请联系管理员!');
						return;
					}
				})
			},
			resetPassword() {
				var temp = this;
				var yzm = this.user.yzm;
				var password = this.user.password;
				var comfrim = this.confirmPassword;
                var ispwd=/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,}$/;

				if(yzm.trim() == '') {
					$(".tip_yz").text('验证码不能为空');
					return;
				} else if(password.trim() == '' || comfrim.trim() == '') {
					$(".tip_yz").text('密码不能为空');
					return;
				} else if(!ispwd.test(password)) {
					$(".tip_yz").text('密码由8位以上数字、字母和特殊符号组成');
					return;
				} else if(!comfrim.test(password)) {
					$(".tip_yz").text('密码由8位以上数字、字母和特殊符号组成');
					return;
				} else if(password != comfrim.trim()) {
					$(".tip_yz").text('密码输入不一致');
					return;
				} else if(this.user.yzm != this.user.setMess) {
					$(".tip_yz").text('验证码输入错误,请重新输入');
					return;
				}
				var time1 = new Date();
				time1.setHours(0); //获取当前小时数(0-23)
				time1.setMinutes(0); //获取当前分钟数(0-59)
				time1.setSeconds(0); //获取当前秒数(0-59)
				time1.setMilliseconds(0); //获取当前毫秒数(0-999)
				var startTime = time1;
				var time2 = new Date();
				time2.setHours(23); //获取当前小时数(0-23)
				time2.setMinutes(59); //获取当前分钟数(0-59)
				time2.setSeconds(59); //获取当前秒数(0-59)
				time2.setMilliseconds(999); //获取当前毫秒数(0-999)
				var endTime = time2;
				var user = this.user;
				user.startTime = startTime.valueOf();
				user.endTime = endTime.valueOf();
				user.yzmlx = '2';
				var formData = JSON.stringify(user);
				this.$http.post('/zklccloud/register/checkCodeInvalid', formData, {
					emulateJSON: true
				}).then(function(m) {
					//获取当前时间戳
					var timestamp = (new Date()).valueOf();
					if(timestamp > m.body.content.endTime) {
						$(".tip_yz").text('验证码已失效,请重新发送验证码！');
					} else {
						$.ajax({
							url: "/zklccloud/resetPassword",
							type: "post",
							dataType: "json",
							data: {
								mobile: this.csmobile,
								password: comfrim
							},
							success: function(m) {
								MessageBox('密码重置成功！', '提示', 'success', {
									confirmButtonText: '确定',
								}).then(() => {
									temp.$router.push("/login");
								});
								if($(".el-message-box__btns")) {
									$(".el-message-box__btns").attr("id", "btnSub");
								}
								//									alert("密码重置成功");
								//									temp.$router.push("/login");
								/*temp.trueFlag = true;
								$("#one").modal().find(".state_text").html('密码重置成功！');
								temp.tipNum='1';*/
							}
						})
					}
				});

			},
		}
	}
</script>

<style scoped>
	.login_forget_register_box {
		min-height: 100%;
		background: url(img/bg-forget.png) no-repeat center center;
		-webkit-background-size: 100%;
		background-size: 100%;
	}

	.login_forget_register_box .container {
		min-height: 600px;
	}

	.login_box {
		width: 340px;
		padding: 10px;
	}
</style>



// WEBPACK FOOTER //
// forget_password.vue?45b1cd18